<cdss-patient-detail-header
    [patientId]="patientId"
    (goBack)="goBack()"
    (patientLoaded)="onPatientLoaded($event)">
</cdss-patient-detail-header>

<div class="weekly-panel position-relative">
    <overlay-spinner *ngIf="loading"></overlay-spinner>

    <!-- Panel shell header -->
    <div class="panel-header">
        <div class="panel-header__title-row">
            <h2 class="panel-title">Weekly Summary</h2>
            <cdss-daily-patient-carer-toggle
                *ngIf="showPatientCarerToggle"
                active="patient"
                (select)="onPatientCarerToggleSelect($event)">
            </cdss-daily-patient-carer-toggle>
        </div>
        <!-- Week navigation row -->
        <div class="week-nav-metrics-row" *ngIf="dateStart">
            <div class="week-nav-side">
                <button class="week-nav-arrow" (click)="navigateToPrevWeek()" title="Previous week">
                    <i class="bi bi-chevron-left"></i>
                </button>
                <div class="week-nav-label">
                    <span class="week-nav-label__week">{{ weekLabel }}</span>
                    <span class="week-nav-label__range">{{ weekRangeLabel }}</span>
                </div>
                <button
                    class="week-nav-arrow"
                    (click)="navigateToNextWeek()"
                    [disabled]="isCurrentWeek"
                    [class.disabled]="isCurrentWeek"
                    title="Next week">
                    <i class="bi bi-chevron-right"></i>
                </button>
            </div>
        </div>
        <!-- Adherence donuts — own row, left-aligned, separated from week selection (UNIVAPLAT-2360 follow-up) -->
        <cdss-weekly-adherence-donuts
            *ngIf="!loading && (snapshot || noData)"
            class="week-adherence-row"
            [class.main-columns--disabled]="noData"
            [attr.inert]="noData ? '' : null"
            [adherence]="adherence"
            type="patient">
        </cdss-weekly-adherence-donuts>
    </div>

    <!-- Main content -->
    <ng-container *ngIf="!loading && (snapshot || noData)">

        <!-- Visible, non-inert no-data statement (the dimmed blocks are inert, so hidden from assistive tech) -->
        <p class="no-data-status" role="status" *ngIf="noData">No data recorded for this week.</p>

        <!-- 4-panel layout (UNIVAPLAT-3036): two independently-stacking flex columns
             (not CSS Grid) so a tall panel in one column never forces a gap under a
             shorter panel in the other — left: Surveys, Daily check-ins this week,
             Behaviours; right: Chapter progress. Stacks to a single column, same
             order, on narrow viewports. -->
        <div class="main-columns" [class.main-columns--disabled]="noData" [attr.inert]="noData ? '' : null">

            <div class="col-left">

                <!-- Surveys -->
                <div class="section-card mb-3">
                    <h3 class="section-title"><i class="bi bi-clipboard-pulse me-2"></i>Surveys</h3>
                    <cdss-weekly-survey-card
                        [surveys]="ed15Surveys"
                        [patientId]="patientId">
                    </cdss-weekly-survey-card>
                </div>

                <!-- Daily check-ins this week -->
                <div class="section-card mb-3">
                    <h3 class="section-title"><i class="bi bi-graph-up me-2"></i>Daily check-ins this week</h3>
                    <cdss-weekly-daily-checkins-rollup
                        [dailyCheckins]="dailyCheckinsRollup">
                    </cdss-weekly-daily-checkins-rollup>
                </div>

                <!-- Behaviours — exact same component/rendering as the Daily Summary page -->
                <div class="section-card">
                    <cdss-daily-behaviour-panel
                        [behaviours]="patientBehaviourLog"
                        variant="patient">
                    </cdss-daily-behaviour-panel>
                </div>

            </div>

            <div class="col-right">

                <!-- Chapter progress — same plain title style as the Daily Summary page -->
                <div class="section-card">
                    <h3 class="section-title"><i class="bi bi-book me-2"></i>Chapter progress</h3>
                    <cdss-weekly-chapter-list
                        [chapters]="chapters"
                        [careProgramId]="snapshot?.userCareProgramId ?? null"
                        [noDataText]="noData ? 'No chapter data for this week.' : null">
                    </cdss-weekly-chapter-list>
                </div>

            </div>

        </div>

    </ng-container>
</div>
